var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsNotificationsAlertOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.07,55.27H47.93V39.5h4.14ZM50,59.74a2.38,2.38,0,1,0,2.38,2.38A2.37,2.37,0,0,0,50,59.74Zm36,2L77.91,58l-7-22.69A9,9,0,0,0,62.29,29H37.71a9,9,0,0,0-8.58,6.34L22.09,58,14,61.71V74H86ZM81.5,69.5h-63V64.6L24,62.12l1.84-.83.6-1.93,7-22.69a4.48,4.48,0,0,1,4.3-3.17H62.28a4.48,4.48,0,0,1,4.3,3.17l7,22.69.6,1.93,1.84.83L81.5,64.6ZM60,80.75H40a15.32,15.32,0,0,0,20.08,0ZM37.33,24.5h4.9a9,9,0,0,1,15.54,0h4.9a13.42,13.42,0,0,0-25.34,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsNotificationsAlertOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Notifications-Alert_Outline_Black_RGB.8d41016bd49be05895bfbfe0e3921044.svg";
export { ForwardRef as ReactComponent };